import { BadgeType } from 'interfaces/dealer-opinions.interface';
import sskBasic from 'assets/images/icons/ssk_basic.svg';
import sskSilver from 'assets/images/icons/ssk_silver.svg';
import sskGold from 'assets/images/icons/ssk_gold.svg';
import sskPlatinum from 'assets/images/icons/ssk_platinum.svg';

export default function getBadge(badgeType: BadgeType): string {
    if (badgeType === 'BASIC') {
        return sskBasic;
    }

    if (badgeType === 'SILVER') {
        return sskSilver;
    }

    if (badgeType === 'GOLD') {
        return sskGold;
    }

    if (badgeType === 'PLATINUM') {
        return sskPlatinum;
    }

    return '';
}
